import type { WbgtLevel } from '@heat-pwa/types';

/**
 * 環境省 公式 5段階スケール（apps/worker/src/lib/wbgtScale.ts と同期）。
 * 数値が変わったら両方を更新すること。Tailwind palette
 * (tailwind.config.js の colors.wbgt) もここの hex に揃える。
 */
export type WbgtBand = {
  level: WbgtLevel;
  min: number;
  max: number;
  label: string;
  color: string;
  shortLabel: string;
};

export const WBGT_SCALE: readonly WbgtBand[] = [
  { level: 5, min: 31,        max: Infinity, label: '危険',     shortLabel: '危険',  color: '#7e0023' },
  { level: 4, min: 28,        max: 31,       label: '厳重警戒', shortLabel: '厳重',  color: '#e60012' },
  { level: 3, min: 25,        max: 28,       label: '警戒',     shortLabel: '警戒',  color: '#ef8200' },
  { level: 2, min: 21,        max: 25,       label: '注意',     shortLabel: '注意',  color: '#f3c700' },
  { level: 1, min: -Infinity, max: 21,       label: 'ほぼ安全', shortLabel: '安全',  color: '#1d8eff' },
] as const;

export function bandForLevel(level: WbgtLevel): WbgtBand {
  return WBGT_SCALE.find((b) => b.level === level) ?? WBGT_SCALE[WBGT_SCALE.length - 1]!;
}

export function classifyWbgt(value: number): WbgtLevel {
  for (const band of WBGT_SCALE) {
    if (value >= band.min && value < band.max) return band.level;
  }
  return 1;
}
